<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h4 class="page-header-title">Input Gadai Elektronik</h4>
                    <span class="page-header-subtitle">Pilih anggota terlebih dahulu, form data barang muncul setelahnya.</span>
                </div>
                <div class="step-badge">
                    <span class="step-dot"></span> Langkah 1 dari 2
                </div>
            </div>

            <b-form @submit.prevent="calculateMaksimumPinjaman">
                <!-- 1. DATA ANGGOTA -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA ANGGOTA</span>
                        <div class="section-card-actions">
                            <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" class="btn-pill-primary">
                                Pilih Anggota
                            </b-button>
                            <b-button @click="addAnggota" name="modalAddAnggotaBtn" class="btn-pill-outline">
                                Anggota Baru
                            </b-button>
                        </div>
                    </div>
                    <div class="section-card-body">
                        <div class="member-info-panel mb-3">
                            <b-row>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Anggota</span>
                                        <span class="member-item-value font-weight-bold">{{ anggota.no }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Identitas</span>
                                        <span class="member-item-value">{{ anggota.noIdentitas }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. HP</span>
                                        <span class="member-item-value">{{ anggota.noHp }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Alamat</span>
                                        <span class="member-item-value">{{ anggota.alamat }}</span>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="member-item-row">
                                        <span class="member-item-label">Jenis Identitas</span>
                                        <span class="member-item-value">{{ anggota.jenisIdentitas }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">Nama</span>
                                        <span class="member-item-value">{{ anggota.nama }}</span>
                                    </div>
                                    <div class="member-item-row">
                                        <span class="member-item-label">No. Rumah</span>
                                        <span class="member-item-value">{{ anggota.noRumah }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="d-flex" v-if="anggota.no != '-'">
                            <b-button class="btn-outline-neutral mr-2" @click="$bvModal.show('modal-edit-anggota')">
                                Edit Anggota
                            </b-button>
                            <b-button class="btn-outline-neutral" @click="$bvModal.show('modal-detail-anggota')">
                                Detail Anggota
                            </b-button>
                        </div>
                    </div>
                </div>

                <!-- 2. DATA BARANG -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA BARANG</span>
                    </div>
                    <div class="section-card-body">
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Jenis Barang">
                                    <b-form-select v-model="input.jenisBarang" name="gadaiJenisBarang">
                                        <template v-slot:first>
                                            <b-form-select-option :value="[ { id: null, name: null } ]" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekJenis" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Merk Barang">
                                    <b-form-select v-model="input.merkBarang" name="gadaiMerkBarang" :disabled="optElekMerk.length == 0">
                                        <template v-slot:first>
                                            <b-form-select-option :value="[ { id: null, name: null } ]" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekMerk" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Tipe">
                                    <multiselect
                                        name="gadaiTipeBarang"
                                        v-model="input.tipeBarang" 
                                        :disabled="optElekTipe.length == 0"
                                        :options="optElekTipe" 
                                        :internal-search="true"
                                        :allow-empty="true"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                        placeholder="-- Please select an option --"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="4" v-if="optElekTahun.length != 0">
                                <b-form-group label="Tahun">
                                    <b-form-select v-model="input.tahun" name="tahunElektronik">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                            <b-form-select-option v-for="(item, idx) in optElekTahun" v-bind:value="{ id: item.id, name: item.name }" v-bind:key="idx">
                                                {{ item.name }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col :md="optElekTahun.length != 0 ? '4' : '6'">
                                <b-form-group label="Kondisi / Grade Barang">
                                    <b-form-select v-model="input.kondisi" name="gadaiGradeBarangClass" :options="optElekKondisi" :disabled="optElekKondisi.length == 0">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col :md="optElekTahun.length != 0 ? '4' : '6'">
                                <b-form-group label="Warna">
                                    <b-form-select v-model="input.warnaBarang" name="gadaiWarnaBarang" :options="optElekWarna">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="6">
                                <b-form-group label="No. Imei/ SN">
                                    <b-form-input v-model="input.noImei" name="gadaiNoImei" required></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Password" description="Bila barang gadai tidak menggunakan password, input ini dapat dikosongkan.">
                                    <b-form-input v-model="input.password" name="gadaiPassword" placeholder="kosongkan bila barang tidak menggunakan password"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-form-group label="Kondisi / Kerusakan / Keterangan Lainnya">
                            <b-form-textarea
                                id="textarea"
                                v-model="input.keterangan" name="gadaiKondisi"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                            <div class="small text-muted mt-1">
                                * Dapat digunakan juga untuk mencatat detil barang gadai bilamana barang tidak ditemukan (pilihan 'Lainnya').
                            </div>
                        </b-form-group>

                        <b-form-group label="Kelengkapan Barang">
                            <div v-if="optKelengkapanBarang.length == 0" class="text-muted small">
                                Tidak ada kelengkapan dari jenis barang yang dipilih.
                            </div>
                            <b-form-checkbox-group class="custom-checkbox-pill-group" v-else v-model="input.kelengkapanBarang" name="gadaiKelengkapanBarang">
                                <b-form-checkbox v-for="item in optKelengkapanBarang" v-bind:key="item.id" :value="{ id: item.id, name: item.name }">
                                    {{ item.name }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>

                        <b-row class="mt-4">
                            <b-col md="6">
                                <label class="font-weight-bold text-dark d-block mb-2" style="font-size: 13px;">Spesifikasi Barang (Jenis)</label>
                                <div class="mb-2">
                                    <span class="text-muted small font-weight-bold d-block mb-1">Penambahan</span>
                                    <div v-if="optElekSpekJenis.penambahan.length == 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi dari jenis barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiBarangJenis" name="gadaiPenambahanSpekJenisBarang">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekJenis.penambahan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div>
                                    <span class="text-muted small font-weight-bold d-block mb-1">Pengurangan</span>
                                    <div v-if="optElekSpekJenis.pengurangan.length == 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi dari jenis barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiBarangJenis" name="gadaiPenguranganSpekJenisBarang">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekJenis.pengurangan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                            <b-col md="6">
                                <label class="font-weight-bold text-dark d-block mb-2" style="font-size: 13px;">Spesifikasi Barang (Merk)</label>
                                <div class="mb-2">
                                    <span class="text-muted small font-weight-bold d-block mb-1">Penambahan</span>
                                    <div v-if="optElekSpekMerk.penambahan.length == 0" class="text-muted small mb-2">
                                        Tidak ada penambahan spesifikasi dari merk barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiBarangMerk" name="gadaiPenambahanSpekMerkBarangElektronik">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekMerk.penambahan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <div>
                                    <span class="text-muted small font-weight-bold d-block mb-1">Pengurangan</span>
                                    <div v-if="optElekSpekMerk.pengurangan.length == 0" class="text-muted small mb-2">
                                        Tidak ada pengurangan spesifikasi dari merk barang yang dipilih.
                                    </div>
                                    <b-form-checkbox-group class="checkbox-group" v-else v-model="input.spesifikasiBarangMerk" name="gadaiPenguranganSpekMerkBarangElektronik">
                                        <b-form-checkbox class="d-block mb-1" v-for="item in optElekSpekMerk.pengurangan" v-bind:key="item.id" :value="item.id">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <!-- 3. DATA PENDUKUNG -->
                <div class="section-card">
                    <div class="section-card-header">
                        <span class="section-card-title">DATA PENDUKUNG</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-pill-primary mb-3" @click="addFotoPendukung" name="fotoPendukungAddBtn">
                            <i class="fa fa-plus mr-1"></i> Foto Pendukung
                        </b-button>
                        <div class="text-danger small mb-3" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
                    
                        <FotoPendukung 
                            v-for="item in input.fotoPendukung" 
                            v-bind:key="item.index" 
                            :fotoPendukung="item" 
                            :length="input.fotoPendukung.length" 
                            :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung"
                            @showModalCam="openModalCam" 
                            @showModalPreview="openModalPreview"
                        />
                        <div class="small text-muted mt-2">
                            * Foto Pendukung maksimal 6 foto.
                        </div>
                    </div>
                </div>

                <!-- 4. PROMO -->
                <div class="section-card">
                    <div class="section-card-header section-card-header--promo">
                        <span class="section-card-title">PROMO</span>
                    </div>
                    <div class="section-card-body">
                        <b-button class="btn-outline-neutral" @click="checkPromo" :disabled="isGettingPromo">
                            {{ isGettingPromo ? "Mengambil..." : "Cek Promo yang Dapat Digunakan" }}
                            <i class="fa fa-search ml-2"></i>
                        </b-button>
                        <div class="detail-promo-data mt-3" v-if="!isGettingPromo && isPromoRetrieved">
                            <div v-if="optPromo.length == 0" class="text-danger small">
                                * Tidak ada promo yang bisa digunakan untuk pemilihan barang gadai ini.
                            </div>
                            <b-form-checkbox-group v-else v-model="input.promo" name="promoList" stacked>
                                <b-form-checkbox class="mb-1 font-weight-500" v-for="item in optPromo" v-bind:key="item.id" :value="item.id">{{ item.name }}</b-form-checkbox>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </div>

                <!-- 5. HARGA BARANG LAINNYA -->
                <div class="section-card" v-if="showDataLainnya && input.merkBarang.name == 'Lainnya'">
                    <div class="section-card-header">
                        <span class="section-card-title">HARGA BARANG LAINNYA</span>
                    </div>
                    <div class="section-card-body">
                        <b-form-group label="Nominal Harga">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.nominalHargaLainnya" name="nominalHargaLainnya" required></b-form-input>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="Nominal Admin Fee" class="mt-3">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.nominalAdminFeeLainnya" name="nominalAdminFeeLainnya" required></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </div>

                <!-- SUBMIT ACTION -->
                <div class="d-flex justify-content-end mb-4">
                    <b-button type="submit" name="gadaiSubmitBtn" class="btn-pill-primary" style="padding: 10px 32px !important; font-size: 15px !important;" :disabled="isSubmitting">
                        {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                    </b-button>
                </div>
            </b-form>

            <b-modal id="modal-input-anggota" body-class="modal-nopadding" size="xl" title="Input Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <InputAnggota :isModal="modalAnggota" @submitModalAnggota="inputNewAnggota" />
            </b-modal>
            <b-modal id="modal-edit-anggota" body-class="modal-nopadding" size="xl" title="Edit Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <EditAnggota :isModal="modalAnggota" :idAnggota="anggota.id" @updateModalAnggota="editNewAnggota" />
            </b-modal>
            <b-modal id="modal-detail-anggota" body-class="modal-nopadding" size="xl" title="Detail Anggota" no-close-on-backdrop>
                <DetailAnggota :isModal="modalAnggota" :idAnggota="anggota.id" />
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="cancelDetailAnggotaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>
            <ModalPilihAnggota @anggota-selected="selectAnggota" />
            <ModalRincian :namaLengkapBarang="namaLengkapBarang" :rincian="rincian" :isSubmitting="isSubmitting" @next="calculateConfirmation" />
            <ModalKonfirmasi 
                :isSubmitting="isSubmitting" :nilaiPinjaman="input.nilaiPinjaman"
                :anggota="anggota" :rincian="rincian" :namaLengkapBarang="namaLengkapBarang"
                @exec-submit="submitGadai"
            />
            <ModalSukses :rincian="rincian" @done="reset" />
            <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult"  />
            <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
            <b-modal id="modal-info-update" title="Update Data Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <p>Mohon klik tombol Edit Anggota dan pastikan data anggota sudah sesuai dengan kartu identitas anggota!</p>
                <p>
                    <strong>
                        Pastikan alamat (kota, kecamatan, kelurahan) dan foto identitas sudah benar.
                    </strong>
                </p>
                <p>
                    Catatan: Bila data sudah benar semua dari awal, mohon untuk tetap menekan tombol Update ketika Edit Anggota.
                </p>
                <b-button variant="pgiBtn" class="mr-2" @click="showModalEditAnggota()">
                    <i class="fa fa-pencil mr-2"></i>
                    Edit Anggota
                </b-button>
            </b-modal>
        </div>
    </div>
</template>

<script>
import ModalPilihAnggota from '../ModalPilihAnggota'
import ModalRincian from '../ModalRincian'
import ModalKonfirmasi from '../ModalKonfirmasi'
import ModalSukses from '../ModalSukses'
import InputAnggota from '../../master/anggota/InputAnggota'
import EditAnggota from '../../master/anggota/EditAnggota'
import DetailAnggota from '../../master/anggota/DetailAnggota'
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'

export default {
    name: 'input-gadai-elektronik',
    components: {
        ModalPilihAnggota,
        ModalRincian,
        ModalKonfirmasi,
        ModalSukses,
        InputAnggota,
        EditAnggota,
        DetailAnggota,
        FotoPendukung,
        ModalWebCam,
        ModalPreview
    },
    data() {
        return {
            initStatus: 0,
            isGettingPromo: false,
            isPromoRetrieved: false,
            isSubmitting: false,

            modalAnggota: true,

            anggota: {
                id: null,
                nama: "-",
                no: "-",
                jenisBarang: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                isComplete: false,
                shouldUpdate: false
            },

            rincian: {
                hargaBarang: 0,
                maksimumPinjaman: 0,
                minimumPinjaman: 0,
                perhitunganPromo: null,
                perhitunganKondisi: {},
                perhitunganSpek: [],
                perhitunganBonusGadaiPertama: {},
                perhitunganStatusAnggota: {},
                biayaAdmin: 0,
                noFaktur: "",
                showAlertNoFakturGanda: "false",
                alertNoImei: "",
                alertNoFakturGanda: "",
                alertGadai: "elek"
            },

            namaLengkapBarang: "",

            input: {
                noImei: null,
                password: "",
                jenisBarang: [ { id: null, name: null } ],
                merkBarang: [ { id: null, name: null } ],
                tipeBarang: null,
                tahun: null,
                kondisi: null,
                kelengkapanBarang: [],
                spesifikasiBarangJenis: [],
                spesifikasiBarangMerk: [],
                warnaBarang: null,
                keterangan: "",
                promo: [],
                nilaiPinjaman: 0,

                fotoPendukung: [
                    {
                        index: 0, 
                        id: 0, 
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],

                nominalHargaLainnya: null,
                nominalAdminFeeLainnya: null
            },

            indexFotoPendukung: 1,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 1,
            activeFotoPreview: "",

            jenisIdentitas: [],
            requiredForDataKerabatAndPihakLain: false,
            tarifSelected: null,
            selected: null,

            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],
            optElekTahun: [],
            optElekKondisi: [],
            optElekWarna: [],
            optKelengkapanBarang: [],
            optElekSpekJenis: {
				penambahan : [],
				pengurangan : []
			},
            optElekSpekMerk: {
				penambahan : [],
				pengurangan : []
			},
            optPromo: [],
            cabangId: '',
            showDataLainnya : 'false'

        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------
        init() {

            this.initStatus = 0

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data
            })

            let getWarnaElek = this.$axios.get("gadai/warna").then(response => {
                this.optElekWarna = response.data.map(item => { return { value: item.id, text: item.name } })
            })

            Promise.all([getJenisElek, getWarnaElek]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

            this.cabangId = this.$helper.getCabangId()
        },

        reset() {

            this.$bvModal.hide("modal-sukses")
            this.$bvModal.hide("modal-konfirmasi")
            this.$bvModal.hide("modal-rincian")

            this.anggota.id = null
            this.anggota.nama = "-"
            this.anggota.no = "-"
            this.anggota.jenisIdentitas = "-"
            this.anggota.noIdentitas = "-"
            this.anggota.noHp = "-"
            this.anggota.noRumah = "-"
            this.anggota.alamat = "-"

            this.input.jenisBarang = [{ id: null, name: null } ]
            this.input.merkBarang = [{ id: null, name: null } ]
            this.input.tipeBarang = null
            this.input.tahun = null
            this.input.kondisi = null
            this.input.kelengkapanBarang = []
            this.input.spesifikasiBarangJenis = []
            this.input.spesifikasiBarangMerk = []
            this.input.warnaBarang = null
            this.input.keterangan = ""
            this.input.noImei = ""
            this.input.password = ""
            this.input.promo = []
            this.input.fotoPendukung = [
                {
                    id: 0, 
                    index: this.indexFotoPendukung, 
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                }
            ]
            window.scroll(0, 0)

        },

        addAnggota() {
            this.$bvModal.show("modal-input-anggota");
        },

        openSearchAnggotaModal() {
            this.$bvModal.show("modal-pilih-anggota")
        },

        selectAnggota(item) {

            this.anggota.id = item.id
            this.anggota.nama = item.nama
            this.anggota.no = item.no
            this.anggota.jenisIdentitas = item.jenisIdentitas.name
            this.anggota.noIdentitas = item.noIdentitas
            this.anggota.noHp = item.noHp
            this.anggota.noRumah = item.noRumah
            this.anggota.alamat = item.alamat
            this.anggota.isComplete = item.isComplete
            this.anggota.shouldUpdate = item.shouldUpdateData
            if(this.anggota.shouldUpdate == true){
                this.$bvModal.hide("modal-pilih-anggota")
                this.$bvModal.show("modal-info-update")
            }else{
                this.$bvModal.hide("modal-pilih-anggota")
            }
        },

        showModalEditAnggota(){
            this.$bvModal.show("modal-edit-anggota")
            this.$bvModal.hide("modal-info-update")
        },

        checkPromo() {

            if(this.input.jenisBarang !== null && this.input.merkBarang !== null && this.input.tipeBarang !== null) {

                if(this.optElekTahun.length != 0 && this.input.tahun == null) {
                    this.$helper.toastErr(this, "Mohon lengkapi jenis, merk, tipe, dan tahun barang terlebih dahulu")
                    return
                }

                let path = 'gadai-crud/promo?jenisPinjamanId=1&jenisBarangId=' + this.input.jenisBarang.id + '&merkId=' + this.input.merkBarang.id + '&tipeId=' + this.input.tipeBarang.id + '&cabangId=' + this.cabangId
                if(this.input.tahun != null) {
                    path += "&tahunId=" + this.input.tahun.id
                }

                this.input.promo = []
                
                this.isGettingPromo = true
                this.$axios.get(path).then(response => {
                    this.optPromo = response.data
                    this.isPromoRetrieved = true
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isGettingPromo = false
                })

            }
            else {
                this.$helper.toastErr(this, "Mohon lengkapi jenis, merk, dan tipe barang terlebih dahulu")
            }

        },

        calculateMaksimumPinjaman() {

            // Check all data has been filled
            if(this.anggota.id == null) {
                this.$helper.toastErr(this, "Mohon memilih anggota terlebih dahulu!")
                return
            }

            if(this.input.jenisBarang == null || this.input.merkBarang == null || this.input.warnaBarang == null
                || this.input.tipeBarang == null || this.input.kondisi == null
            ) {
                this.$helper.toastErr(this, "Mohon lengkapi data gadai terlebih dahulu!")
                return
            }

            if(this.input.jenisBarang.name == 'Handphone' && this.input.noImei.length != 15){
                this.$helper.toastErr(this, "Apabila jenis barangnya Handphone, IMEI harus 15 karakter")
                return
            }

            if(this.optElekTahun.length > 0 && this.input.tahun == null) {
                this.$helper.toastErr(this, "Mohon lengkapi data gadai terlebih dahulu!")
                return
            }

            // Check if there is at least one picture attached
            if(this.input.fotoPendukung.length == 1 && this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)) {
                this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
                return
            }

            // Check if all photo row has been filled
            for(var i = 0; i < this.input.fotoPendukung.length; i++) {
                let item = this.input.fotoPendukung[i]
                if(this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
                    this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
                    return
                }
            }

            let payload = this.preparePayload()
            this.isSubmitting = true
            this.$axios.post("gadai-crud/gadai/elektronik", payload).then(response => { 

                if(response.data.noFaktur == 'REFRESH_KONDISI'){
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.kondisi = null
                    this.$axios.get(`barang-tipe/kondisi/${this.input.tipeBarang.id}`).then(response => {

                        this.optElekKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name }
                        })

                    })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                }else{
                    let data = response.data
                    this.rincian = data
                    console.log(response.data)

                    if(response.data.noFakturSuspectGanda != null){
                        this.rincian.showAlertNoFakturGanda = true
                        this.rincian.alertNoImei = this.input.noImei
                        this.rincian.alertGadai = "elek"
                        this.rincian.alertNoFakturGanda = response.data.noFakturSuspectGanda
                    }
                
                    // Arrange nama lengkap barang
                    this.namaLengkapBarang = `${this.input.jenisBarang.name} - ${this.input.merkBarang.name} - ${this.input.tipeBarang.name}`
                    if(this.input.tahun != null) {
                        this.namaLengkapBarang += ` - ${this.input.tahun.name}`
                    }

                    this.$bvModal.show("modal-rincian")
                }

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
            
        },

        calculateConfirmation(nilaiPinjaman) {
            if (nilaiPinjaman % 50000 != 0) this.$helper.toastErr(this, "Pinjaman hanya boleh dalam kelipatan Rp 50.000")
            else {

                let payload = this.preparePayload(nilaiPinjaman)
        
                this.isSubmitting = true
                this.$axios.post("gadai-crud/gadai/elektronik", payload).then(response => { 

                    if(response.data.noFaktur == 'REFRESH_KONDISI'){
                        this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                        this.input.kondisi = null
                        this.$axios.get(`barang-tipe/kondisi/${this.input.tipeBarang.id}`).then(response => {

                            this.optElekKondisi = response.data.map(item => {
                                return { value: item.id, text: item.name }
                            })

                        })
                        .catch(error => {
                            this.$helper.parseError(this, error)
                        })
                        this.$bvModal.hide("modal-rincian")
                    }else{
                        let data = response.data
                        this.rincian = data
                        console.log(response.data)
                        this.$bvModal.show("modal-konfirmasi")
                    }

                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })

            }

        },

        submitGadai() {
            let payload = this.preparePayload(this.input.nilaiPinjaman, true)

            this.isSubmitting = true
            this.$axios.post("gadai-crud/gadai/elektronik", payload, { timeout: 300000 }).then(response => {

                if(response.data.noFaktur == 'REFRESH_KONDISI'){
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.kondisi = null
                    this.$axios.get(`barang-tipe/kondisi/${this.input.tipeBarang.id}`).then(response => {

                        this.optElekKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name }
                        })

                    })
                    this.$bvModal.hide("modal-konfirmasi")
                    this.$bvModal.hide("modal-rincian")
                }else{
                    let data = response.data
                    this.rincian.noFaktur = data.noFaktur

                    this.$bvModal.show("modal-sukses")
                }
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        preparePayload(nilaiPinjaman = null, finalizePayment = false) {

            let payload = new FormData()
            payload.append("nasabahId", this.anggota.id)
            payload.append("jenisPinjamanId", 1) // MARK HARDCODE
            payload.append("jenisBarangId", this.input.jenisBarang.id)
            payload.append("merkId", this.input.merkBarang.id)
            payload.append("tipeId", this.input.tipeBarang.id)
            payload.append("kondisiId", this.input.kondisi)
            payload.append("cabangId", this.cabangId)
            payload.append("finalizePayment", finalizePayment)
            payload.append("warnaId", this.input.warnaBarang)
            payload.append("imeiSn", this.input.noImei)
            
            payload.append("keterangan", this.input.keterangan)

            let nominalHargaLainnya = this.$helper.removeThousandSeparator(this.input.nominalHargaLainnya)
            let nominalAdminFeeLainnya = this.$helper.removeThousandSeparator(this.input.nominalAdminFeeLainnya)

            if(this.$helper.isNotNullAndNotEmpty(this.input.nominalHargaLainnya)) payload.append("hargaBarangLainnya", nominalHargaLainnya)
            if(this.$helper.isNotNullAndNotEmpty(this.input.nominalAdminFeeLainnya)) payload.append("adminFeeLainnya", nominalAdminFeeLainnya)

            // Append all checked spesifikasi
            for(let spek of this.input.spesifikasiBarangJenis) {
                payload.append("spesifikasiId", spek)
            }

            for(let spek of this.input.spesifikasiBarangMerk) {
                payload.append("spesifikasiId", spek)
            }

            // Append promo, if any is selected
            this.input.promo.forEach(promoId => {
                payload.append("promoIds", promoId)
            })

            // Kelengkapan
            if(this.input.kelengkapanBarang.length != 0) {

                this.input.kelengkapanBarang.forEach(item => {
                    payload.append("kelengkapan", item.name)
                })

            }
            
            // Append tahun, if selected
            if(this.$helper.isNotNullAndNotEmpty(this.input.tahun)) {
                payload.append("tahunId", this.input.tahun.id)
            }

            // Append peminjaman, if nilai pinjaman is not null
            if(nilaiPinjaman != null) {
                this.input.nilaiPinjaman = nilaiPinjaman
                payload.append("jumlahPinjaman", nilaiPinjaman)
            }

            // Upload photo only if on final step
            if(finalizePayment) {

                let jsonFoto = []
                this.input.fotoPendukung.forEach(function(entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)  
                })
                payload.append("foto", JSON.stringify(jsonFoto))
                if(this.$helper.isNotNullAndNotEmpty(this.input.password)){
                    payload.append("password", this.input.password)
                } 
            }

            this.$helper.printPayload(payload)

            return payload

        },

        inputNewAnggota(dataAnggota){
            //hide modal confirm dan modal anggota
            
            this.$bvModal.hide("modal-confirm-input");
            this.$bvModal.hide("modal-input-anggota");
            this.anggota.id = dataAnggota.idAnggota
            this.anggota.nama = dataAnggota.nama
            this.anggota.no = dataAnggota.noAnggota
            this.anggota.jenisIdentitas = dataAnggota.jenisIdentitas.name
            this.anggota.noIdentitas = dataAnggota.noIdentitas
            this.anggota.noHp = dataAnggota.noHp
            this.anggota.noRumah = dataAnggota.noRumah
            this.anggota.alamat = dataAnggota.alamat
            this.anggota.isComplete = dataAnggota.isComplete
        },

        editNewAnggota(dataAnggota){
            //hide modal confirm dan modal anggota
            
            this.$bvModal.hide("modal-confirm-edit");
            this.$bvModal.hide("modal-edit-anggota");
            
            this.anggota.id = dataAnggota.idAnggota
            this.anggota.nama = dataAnggota.nama
            this.anggota.no = dataAnggota.noAnggota
            this.anggota.noIdentitas = dataAnggota.noIdentitas
            this.anggota.noHp = dataAnggota.noHp
            this.anggota.noRumah = dataAnggota.noRumah
            this.anggota.alamat = dataAnggota.alamat
            this.anggota.isComplete = dataAnggota.isComplete
        },

        openModalCam(index){
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        openModalPreview(index){
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
            this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
            this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
            this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
        },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if(this.input.fotoPendukung.length < 6){
                this.input.fotoPendukung.unshift({ 
                    id: 0, 
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++;
            }else{
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

    },

    watch: {

        'input.jenisBarang': function(newVal) {

            this.optElekMerk = []
            this.input.merkBarang = [ { id: null, name: null } ]

            this.optKelengkapanBarang = []
            this.input.kelengkapanBarang = []

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            this.optElekSpekJenis = {
				penambahan : [],
				pengurangan : []
			}
            this.input.spesifikasiBarangJenis = []

            if(newVal == null) { return }

            if(newVal.id != undefined){

                if(this.input.jenisBarang.name.startsWith('Lainnya')){
                    this.showDataLainnya = true
                }
                // Lookup Merk
                this.$axios.get(`barang-merk/jenis/${newVal.id}`).then(response => {
                    this.optElekMerk = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Kelengkapan Barang
                this.$axios.get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`).then(response => {
                    this.optKelengkapanBarang = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Spek Jenis
                this.$axios.get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`).then(response => {
                    this.optElekSpekJenis = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            }

        },

        'input.merkBarang': function(newVal) {

            this.optElekTipe = []
            this.input.tipeBarang = null

            this.optElekSpekMerk = {
				penambahan : [],
				pengurangan : []
			}
            this.input.spesifikasiBarangMerk = []

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if(newVal.id == undefined) { return }

            if(newVal.id != undefined){
                // Lookup Tipe
                this.$axios.get(`barang-tipe/merk/${newVal.id}`).then(response => {
                    this.optElekTipe = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Spek Merk
                this.$axios.get(`barang-merk/spesifikasi?merkId=${newVal.id}`).then(response => {
					this.optElekSpekMerk = response.data
					console.log(response.data)
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            }

        },

        'input.tipeBarang': function(newVal) {
            console.log(newVal)
            this.optElekTahun = []
            this.input.tahun = null

            this.optElekKondisi = []
            this.input.kondisi = null

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

            if(newVal == null) { return }

            if(newVal != null){
                // Lookup Tahun
                this.$axios.get(`barang-tipe/tahun/${newVal.id}`).then(response => {
                    this.optElekTahun = response.data
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })

                // Lookup Kondisi
                this.$axios.get(`barang-tipe/kondisi/${newVal.id}`).then(response => {

                    this.optElekKondisi = response.data.map(item => {
                        return { value: item.id, text: item.name }
                    })

                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            }

        },

        'input.tahun': function(newVal) {

            this.optPromo = []
            this.input.promo = []
            this.isPromoRetrieved = false

        },

        "input.nominalHargaLainnya": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalHargaLainnya = result);
        },

        "input.nominalAdminFeeLainnya": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalAdminFeeLainnya = result);
        },

    },

    created() {
        this.init()
    }
}
</script>
